import { useEffect } from 'react';
import {Modal } from 'react-bootstrap';
import { CameraFeed } from './CameraFeed';

function ModalBootstrap({ uploadCapturedImage, handleClose }) {
    
    const handleCreateImage = async file => {
        uploadCapturedImage(file);
    };
    const handleCloseAndOffCamera = () => {
        handleClose();
        stopCamera();
    };
    const stopCamera = () => {
        var videoEl = document.querySelector('video');
        let stream = videoEl.srcObject;
        let tracks = stream ? stream.getTracks() : "";
        if (tracks && tracks.length > 0){
            tracks.forEach(function (track) {
                track.stop();
            });
        }
        videoEl.srcObject = null;
    }
    useEffect(() => {
        stopCamera();
    }, [])
    
    return (
        <>
            <Modal
                size="md"
                show={true}
                onHide={handleCloseAndOffCamera}
                backdrop="static"
                keyboard={false}
                id="modal-id"
                animation={true}
            >
                <Modal.Header closeButton>
                    <p  className='text-center'>Click on below <b>Capture</b> button to capture the image</p>
                </Modal.Header>
                <Modal.Body>
                    <>
                        <CameraFeed sendFile={handleCreateImage}  />
                    </>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalBootstrap
